import React from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HeroSection } from './sections/HeroSection';
import { ServicesSection } from './sections/ServicesSection';
import { DataCenterSection } from './sections/DataCenterSection';
import { AICapabilitiesSection } from './sections/AICapabilitiesSection';
import { WhyUCenSysSection } from './sections/WhyUCenSysSection';
import { PartnersSection } from './sections/PartnersSection';
import { CaseStudiesSection } from './sections/CaseStudiesSection';
import { AboutSection } from './sections/AboutSection';
import { ContactSection } from './sections/ContactSection';
export function App() {
  return <div className="min-h-screen bg-ucensys-navy text-white selection:bg-ucensys-teal selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <DataCenterSection data-id="element-5" />
        <AICapabilitiesSection data-id="element-6" />
        <WhyUCenSysSection data-id="element-7" />
        <PartnersSection data-id="element-8" />
        <CaseStudiesSection data-id="element-9" />
        <AboutSection data-id="element-10" />
        <ContactSection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}